(function () {
  'use strict';

  function track(eventName, detail) {
    var payload = detail || {};
    payload.event = eventName;
    document.dispatchEvent(new CustomEvent('ln:event', { detail: payload }));
  }

  function init() {
    document.querySelectorAll('[data-ln-withdrawal-entry]').forEach(function (link) {
      if (link.dataset.lnReady === 'true') return;
      link.dataset.lnReady = 'true';
      link.addEventListener('click', function () {
        track('withdrawal_entry_click', {
          page_path: window.location.pathname
        });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());